import { MuSupportType } from 'models/InternalIntegrationSetting';
import { isBusinessTypeSupported } from 'models/InternalIntegrationSetting.utils';
import { PropertyForPropertyListItem } from 'pages/agencyProperties/Properties.types';

const getSupportedPropertyUids = (
  properties: PropertyForPropertyListItem[],
  muSupportType: MuSupportType,
): string[] => {
  const uids: string[] = [];

  properties.forEach((property) => {
    if (
      isBusinessTypeSupported({
        muSupportType,
        businessType: property.businessType,
      })
    ) {
      uids.push(property.uid);
    }

    if ('subUnits' in property && property.subUnits?.length) {
      property.subUnits.forEach((subUnit) => {
        if (
          isBusinessTypeSupported({
            muSupportType,
            businessType: subUnit.businessType,
          })
        ) {
          uids.push(subUnit.uid);
        }
      });
    }

    if ('unitTypes' in property && property.unitTypes?.length) {
      property.unitTypes.forEach((unitType) => {
        if (
          isBusinessTypeSupported({
            muSupportType,
            businessType: unitType.businessType,
          })
        ) {
          uids.push(unitType.uid);
        }
      });
    }
  });

  return uids;
};

export default getSupportedPropertyUids;
